export default __webpack_public_path__ + "img/5f67fe7034189c30fc85aafc63b37306.svg";